export default "__VITE_ASSET__BznRc03X__"